import { useEffect, useState } from "react";
import { useKomutStore, type ResolvedTheme } from "@lib/store";

function resolveTheme(
  theme: "light" | "dark" | "system",
  prefersDark: boolean,
): ResolvedTheme {
  return theme === "system" ? (prefersDark ? "dark" : "light") : theme;
}

export function useTheme() {
  const theme = useKomutStore((state) => state.theme);
  const setTheme = useKomutStore((state) => state.setTheme);
  const toggleTheme = useKomutStore((state) => state.toggleTheme);
  const [prefersDark, setPrefersDark] = useState(() =>
    typeof window !== "undefined"
      ? window.matchMedia("(prefers-color-scheme: dark)").matches
      : false,
  );
  const resolvedTheme = resolveTheme(theme, prefersDark);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    const handler = (e: MediaQueryListEvent) => setPrefersDark(e.matches);
    mediaQuery.addEventListener("change", handler);
    return () => mediaQuery.removeEventListener("change", handler);
  }, []);

  return { theme, resolvedTheme, setTheme, toggleTheme };
}
